import { BottomSheet } from '@s4l/ds'
import React from 'react'
import { useIntl } from 'react-intl'
import { SearchMode } from 'src/types/search'
import { OmniSearch } from '../Omnisearch'
import styles from './styles.module.css'

interface IOmniSearchProps {
  readonly onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export function OmnisearchBtn({ onClick }: IOmniSearchProps) {
  const intl = useIntl()

  return (
    <BottomSheet snapPoints={[]}>
      <BottomSheet.Trigger className={styles.searchSummary} data-testid="omnisearch-btn">
        <OmniSearch mode={SearchMode.Borderless} disabled />
      </BottomSheet.Trigger>

      <BottomSheet.Content title={intl.formatMessage({ id: 'modify.search' })}>
        <OmniSearch mode={SearchMode.Full} onClick={onClick} />
      </BottomSheet.Content>
    </BottomSheet>
  )
}
